import { type RefObject, useEffect, useSyncExternalStore } from 'react';

let headerHeight = 56;
const listeners = new Set<() => void>();

export const setHeaderHeight = (height: number) => {
    if (height === headerHeight) return;
    headerHeight = height;
    listeners.forEach((listener) => {
        listener();
    });
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

const getSnapshot = () => headerHeight;

export const useHeaderHeight = () => useSyncExternalStore(subscribe, getSnapshot);

type DrawerWithTop = { top: number; computePosition: () => void };

export const useDrawerHeaderOffset = (drawerRef: RefObject<DrawerWithTop | null>) => {
    const height = useHeaderHeight();
    useEffect(() => {
        const drawer = drawerRef.current;
        if (!drawer) return;
        drawer.top = height;
        drawer.computePosition();
    }, [height, drawerRef]);
    return height;
};
